export default __webpack_public_path__ + "static/media/ClusterTruck.f899b827.png";